import { get } from '../utils/token'
import { getLocalStore } from '../utils/localStore'
export const CommunicationGetters = {
  getTag: (state) => state.tag
}
export const UserGetters = {
  getUser: (state) => {
    return state.user || get('user')
  },
  // 获取真实名字
  // getFullName: (state) =>{
  //   if(state.user && state.user.nickName){
  //     if(state.user.fullname !== 'null' && state.user.fullname !==''){}
  //   }
  // },
  getUserNickName: (state) => {
    if (state.user && state.user.nickName) {
      // return state.user.nickName
      return state.user.fullname !== 'null' && state.user.fullname !== '' ? state.user.fullname : state.user.nickName
    }
    const user = get('user')
    if (user && user.fullname) {
      // return user.nickName
      // return user.fullname !== 'null' && user.fullname !== '' ? user.fullname : user.nickName
      return user.fullname
    }
    return '钉钉全称缺失'
  },
  getUserAvater: (state) => {
    if (state.user && state.user.avatar) {
      // return state.user.avatar
      return state.user.real_avatar && state.user.real_avatar !== '' ? state.user.real_avatar : state.user.avatar
    }
    const user = get('user')
    if (user && user.avatar) {
      // return user.avatar
      return user.real_avatar && user.real_avatar !== '' ? user.real_avatar : user.avatar
    }
    // return 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/defaultProfile.png'
    return ''
  }
}
export const RefreshGetters = {
  getDownRefresh: (state) => state.downRefresh
}
export const MessageGetters = {
  getNewMessageCount: (state) => state.newMessageCount,
  getNewStarCircleCount: (state) => state.newStarcircleCount,
  getNewTaleCount: (state) => state.newTaleCount
}
export const TabBarGetters = {
  getTabIndex: (state) => {
    if (state.tabIndex) {
      return state.tabIndex
    }
    const tabIndex = get('tabIndex')
    if (tabIndex) {
      return tabIndex
    }
    return 'find'
  }
}
export const DynamicTabBarGetters = {
  getDynamicTabIndex: (state) => {
    if (state.dynamicTabIndex) {
      return state.dynamicTabIndex
    }
    const tabIndex = get('dynamicTabIndex')
    if (tabIndex) {
      return tabIndex
    }
    return ''
  }
}

export const RouterGetters = {
  getRouter: (state) => {
    // console.log('111********************')
    // console.log(state)
    // console.log('111********************')
    if (state.tabbarRouter.length) {
      return state
    }
    // console.log('222********************')
    // console.log(state)
    // console.log('222********************')
    const router = getLocalStore('router')
    if (router) {
      return router || {}
    }
    // console.log('333********************')
    // console.log(state)
    // console.log('333********************')
    return state
  }
}

export const TarBarModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('home')) {
      return state
    }
    return get('tabbarAuth') || {}
  }
}
export const CenterModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('editInfo')) {
      return state
    }
    return get('centerAuth')
  }
}
export const HomeModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state && state.rotation) {
      return state
    }
    return get('homeAuth')
  }
}
export const DynamicModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('dynamic')) {
      return state
    }
    return get('dynamicAuth')
  }
}

export const MakeComplainsModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('message')) {
      return state
    }
    return get('messageAuth') || {}
  }
}
export const RefiningModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('message')) {
      return state
    }
    return get('refiningAuth') || {}
  }
}
export const CalendarModuleAuthGetters = {
  getAuth: (state) => {
    /* eslint-disable-next-line */
    if (state.hasOwnProperty('create')) {
      return state
    }
    return get('calendarAuth') || {}
  }
}
export const HotTopicListGetters = {
  getAuth: (state) => {
    const result = []
    const count = Math.ceil(state.HotTopic.length / 2)
    for (let i = 0; i < count * 2 - 1;) {
      const data = []
      data[0] = state.HotTopic[i]
      data[1] = state.HotTopic[i + 1]
      i += 2
      if (typeof (data[1]) === 'undefined') {
        data.length = data.length - 1
        // 此条判断是解决当数据出现单数时，仍然会出现一个undefined的元素
      }
      result.push(data)
    }
    return result
  }
}
// 新增解决浏览定位
export const BrowseCoordGetters = {
  getBrowseCoordFindScroll: (state) => {
    return state.findScroll || 0
  },
  getFindListCount: (state) => {
    return state.findListCount || 0
  },
  getDynamicScroll: (state) => {
    return state.dynamicScroll || 0
  }
}
